import { render } from "./new-plans.vue?vue&type=template&id=7db973b0&scoped=true"
import script from "./new-plans.vue?vue&type=script&lang=js"
export * from "./new-plans.vue?vue&type=script&lang=js"

import "./new-plans.vue?vue&type=style&index=0&id=7db973b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db973b0"]])

export default __exports__